import { Injectable } from '@angular/core';

/** Recent Colors Service Manages recent color history using sessionStorage (tab-scoped, global across all instances) */
@Injectable({
  providedIn: 'root',
})
export class RecentColorsService {
  private readonly storageKey = 'hx-color-picker-recent';
  private readonly maxRecent = 5;

  /** Get recent colors from sessionStorage */
  getRecentColors(): string[] {
    try {
      const stored = sessionStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch {
      // Fall back to empty if sessionStorage unavailable or parse error
      return [];
    }
  }

  /**
   * Add a color to recent history
   *
   * - De-duplicates (moves existing to front)
   * - Maintains max 5 entries
   */
  addRecentColor(color: string): void {
    try {
      let recent = this.getRecentColors();

      // Remove duplicate if exists
      recent = recent.filter((c) => c.toLowerCase() !== color.toLowerCase());

      // Add to front
      recent.unshift(color);

      // Limit to max entries
      if (recent.length > this.maxRecent) {
        recent = recent.slice(0, this.maxRecent);
      }

      sessionStorage.setItem(this.storageKey, JSON.stringify(recent));
    } catch {
      // Silent fail if sessionStorage is unavailable
    }
  }

  /** Clear all recent colors */
  clearRecentColors(): void {
    try {
      sessionStorage.removeItem(this.storageKey);
    } catch {
      // Silent fail
    }
  }
}
